import * as React from "react";

const IconDefaultView: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19">
            <path
                fill="currentColor"
                d="M2.5 8.25C1.12 8.25 0 7.129 0 5.75v-2.5A2.5 2.5 0 0 1 2.5.75h15c1.379 0 2.5 1.12 2.5 2.5v2.5c0 1.379-1.121 2.5-2.5 2.5h-15Zm16.25-2.5v-2.5c0-.69-.559-1.25-1.25-1.25h-15c-.69 0-1.25.56-1.25 1.25v2.5C1.25 6.441 1.81 7 2.5 7h15a1.25 1.25 0 0 0 1.25-1.25Zm1.25 10c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5v-2.5c0-1.379 1.12-2.5 2.5-2.5h15c1.379 0 2.5 1.121 2.5 2.5v2.5ZM17.5 17a1.25 1.25 0 0 0 1.25-1.25v-2.5A1.25 1.25 0 0 0 17.5 12h-15c-.69 0-1.25.559-1.25 1.25v2.5c0 .691.56 1.25 1.25 1.25h15Z"
            />
        </svg>
    );
};

export default React.memo(IconDefaultView);
